export function normalizeSearchText(value: string | null | undefined): string {
  return (value ?? '').normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().trim();
}

export function matchesSearch(query: string, fields: (string | null | undefined)[]): boolean {
  const terms = normalizeSearchText(query).split(/\s+/).filter(Boolean);

  if (terms.length === 0) {
    return true;
  }

  const haystack = fields.map(field => normalizeSearchText(field)).filter(Boolean);

  return terms.every(term => haystack.some(field => field.includes(term)));
}
